// extracted by mini-css-extract-plugin
module.exports = {"summaryOverview":"summaryOverview_summaryOverview__nYnE8","summaryRowChange":"summaryOverview_summaryRowChange__fzLSn","summaryRow":"summaryOverview_summaryRow__jFtXh"};